import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reply-form" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = {
  key: 0,
  class: "file-list"
}
const _hoisted_5 = { class: "form-actions" }

import { ref } from 'vue';
import Button from 'primevue/button';
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReplyForm',
  props: {
    parentId: {},
    subject: {}
  },
  emits: ["submit", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const message = ref('');
const attachedFiles = ref<File[]>([]);

function onFileSelect(event: any) {
  const files = event.files;
  if (files && Array.isArray(files)) {
    const validFiles = files.filter((file): file is File => file instanceof File);
    attachedFiles.value.push(...validFiles);
  }
}

function onFileRemove(event: any) {
  const removedFile = event.file;
  attachedFiles.value = attachedFiles.value.filter(
    (f) => f.name !== removedFile.name || f.size !== removedFile.size,
  );
}

function removeFile(index: number) {
  attachedFiles.value.splice(index, 1);
}

function submitReply() {
  if (message.value.trim()) {
    emit('submit', message.value.trim());
    message.value = '';
    attachedFiles.value = [];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("label", { for: "reply-message" }, "Сообщение *", -1)),
      _createVNode(_unref(Textarea), {
        id: "reply-message",
        modelValue: message.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
        rows: "5",
        autoResize: true,
        placeholder: "Введите ваш ответ...",
        style: {"width":"100%"}
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("label", null, "Прикрепить файлы", -1)),
      _createVNode(_unref(FileUpload), {
        name: "replyAttachments[]",
        multiple: true,
        accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx",
        maxFileSize: 20971520,
        customUpload: true,
        auto: false,
        showFileList: false,
        previewWidth: 0,
        chooseLabel: "Выбрать файлы",
        uploadLabel: "Загрузить",
        cancelLabel: "Отмена",
        onSelect: onFileSelect,
        onRemove: onFileRemove,
        files: attachedFiles.value
      }, null, 8, ["files"]),
      (attachedFiles.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachedFiles.value, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "file-item"
              }, [
                _createElementVNode("span", null, _toDisplayString(file.name), 1),
                _createVNode(_unref(Button), {
                  icon: "pi pi-times",
                  severity: "danger",
                  text: "",
                  rounded: "",
                  onClick: ($event: any) => (removeFile(index))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Button), {
        label: "Отправить",
        icon: "pi pi-send",
        disabled: !message.value.trim(),
        onClick: submitReply
      }, null, 8, ["disabled"]),
      _createVNode(_unref(Button), {
        label: "Отмена",
        severity: "secondary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
      })
    ])
  ]))
}
}

})